import { useAtomValue } from 'jotai';

import RadioField from '@rewardopl/react-ui/radio_field';

import { Name, Sub } from './option.styles';

import ErrorBoundary from '../../../error_boundary';

import { integrationBusinessQuery } from '../../../../store';

import { INTEGRATION_NAMES, INTEGRATION_TYPES, INTEGRATIONS } from '../../../../constants';

import type { Integration } from '@rewardopl/types';

type OptionContentProps = {
  checked: boolean;
  integrationBusinessName?: string;
  integrationId: Integration['_id'];
  integrationType: (typeof INTEGRATION_TYPES)[keyof typeof INTEGRATION_TYPES];
  onChange: (integrationId: Integration['_id']) => void;
};

function OptionContent({
  checked,
  integrationBusinessName,
  integrationId,
  integrationType: type,
  onChange,
}: OptionContentProps) {
  const integrationType = (Object.keys(INTEGRATIONS) as (keyof typeof INTEGRATIONS)[]).find(
    (key) => INTEGRATION_TYPES[key] === type,
  );

  if (!integrationType) {
    throw new Error(`Invalid integration type: ${type}`);
  }

  const integrationName = INTEGRATION_NAMES[integrationType];

  return (
    <RadioField
      checked={checked}
      label={
        <>
          <Name>{integrationBusinessName || <em>{integrationId}</em>}</Name>
          <Sub>{integrationName}</Sub>
        </>
      }
      name="integration"
      onChange={onChange}
      value={integrationId}
    />
  );
}

type OptionWrapperProps = {
  checked: boolean;
  integrationId: Integration['_id'];
  integrationType: (typeof INTEGRATION_TYPES)[keyof typeof INTEGRATION_TYPES];
  onChange: (integrationId: Integration['_id']) => void;
};

function OptionWrapper(props: OptionWrapperProps) {
  const { integrationId } = props;
  const integrationBusiness = useAtomValue(integrationBusinessQuery(integrationId));

  return <OptionContent {...props} integrationBusinessName={integrationBusiness?.name} />;
}

function OptionFallbackWrapper(props: OptionWrapperProps) {
  return <OptionContent {...props} />;
}

export default function Option(props: OptionWrapperProps) {
  return (
    <ErrorBoundary fallback={<OptionFallbackWrapper {...props} />}>
      <OptionWrapper {...props} />
    </ErrorBoundary>
  );
}
